<p-dialog appDialogoPadrao="pi pi-plus" descricao="Anotação registrada no cadastro." [(visible)]="showDialog" header="Nova Anotação" [appendTo]="'body'" [breakpoints]="{ '1100px': '65vw', '800px': '70vw', '500px': '95vw' }">
    <ng-template #content>
        <form [formGroup]="form" class="flex flex-col gap-5 min-w-1/4">
            <div class="field w-full">
                <label class="font-semibold block mb-2">Data</label>
                <p-datepicker formControlName="data" [iconDisplay]="'input'" [showIcon]="true" [appendTo]="'body'" dateFormat="dd/mm/yy" />
                @if (form.get('data')?.invalid && form.get('data')?.touched) {
                    <small class="p-error block mt-1">{{ mensagemErroData() }}</small>
                }
            </div>

            <div class="field w-full">
                <label class="font-semibold block mb-2 w-full min-w-[300px]">Anotações</label>
                <textarea pTextarea formControlName="anotacoes" [autoResize]="true" rows="8" maxlength="250" class="w-full"></textarea>
                <div class="flex justify-between mt-1">
                    @if (form.get('anotacoes')?.invalid && form.get('anotacoes')?.touched) {
                        <small class="p-error">Informe a anotação.</small>
                    } @else {
                        <span></span>
                    }
                    <small class="text-muted-color">{{ form.get('anotacoes')?.value?.length ?? 0 }}/250</small>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template #footer>
        <p-button label="Cancelar" icon="pi pi-times" (onClick)="hideDialog()" text [disabled]="salvando()" />
        <p-button label="Salvar" icon="pi pi-check" (onClick)="salvar()" [disabled]="form.invalid || salvando()" [loading]="salvando()" />
    </ng-template>
</p-dialog>
